/**
 * PdfReadyCard — persistent "the PDF is ready" row under an export section.
 *
 * The PDF itself opens in PdfPreviewModal (in-app iframe, never popup
 * blocked) the moment the URL arrives; this card stays behind so the user
 * can reopen the preview or open the file in a new tab (a real anchor — a
 * user click always opens). The history list below offers the same.
 */

import { FilePdf, ArrowSquareOut, CheckCircle } from "@phosphor-icons/react";

/**
 * @param {string} url - download-token PDF URL
 * @param {() => void} onPreview - reopen the in-app preview
 */
function PdfReadyCard({ url, onPreview }) {
  if (!url) return null;
  return (
    <div className="prw-pdf-ready" role="status" aria-live="polite">
      <span className="prw-pdf-ready-icon">
        <CheckCircle size={20} weight="fill" />
      </span>
      <span className="prw-pdf-ready-text">
        <strong>הדוח מוכן</strong>
        <span>נשמר גם ברשימת הדוחות שהופקו למטה.</span>
      </span>
      <span className="prw-pdf-ready-btns">
        {onPreview && (
          <button type="button" className="prw-btn primary prw-pdf-ready-btn" onClick={onPreview}>
            <FilePdf size={15} weight="fill" />
            תצוגה
          </button>
        )}
        <a
          className="prw-btn ghost prw-pdf-ready-btn"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ArrowSquareOut size={15} />
          כרטיסייה חדשה
        </a>
      </span>
    </div>
  );
}

export default PdfReadyCard;
